var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgVirtualBackground = function SvgVirtualBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2H4a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2zM9.096 14.76l2.146 3.112 3.185-7.351a1 1 0 011.81-.055L20 17.88V4H4v15.76l3.45-5a1 1 0 011.646 0zM9 12a3 3 0 110-6 3 3 0 010 6zm1-3a1 1 0 11-2 0 1 1 0 012 0zm5.416 4.269L18.833 20H12.5l2.916-6.731zm-7.143 3.82L10.28 20H6.264l2.009-2.91z"
  })));
};

export default SvgVirtualBackground;